
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

export default {
name: 'user',
props: [],
components: {
XHeader,
Group,
Cell,
Tab,
TabItem
},
data () {
return {
titlepage: this.$route.meta.title,
index: 0,
listTitle: ['同省', '同市', '同区', '同学院', '同专业', '同班级', '同宿舍'],
list: [
{
id: 0,
label: '李明',
phone: '17691237215',
isShow: true
},
{
id: 1,
label: '李明',
phone: '17691237215',
isShow: false
},
{
id: 2,
label: '李明',
phone: '17691237215',
isShow: false
},
{
id: 3,
label: '李明',
phone: '17691237215',
isShow: true
},
{
id: 4,
label: '李明',
phone: '17691237215',
isShow: true
},
{
id: 5,
label: '李明',
phone: '17691237215',
isShow: true
},
{
id: 6,
label: '李明',
phone: '17691237215',
isShow: true
},
{
id: 7,
label: '李明',
phone: '17691237215',
isShow: true
}
]
}
},
computed: {
title () {
return this.$route.meta.title
}
},
created () {},
mounted () {},
methods: {
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/user/userItem/findClassmate.vue